/** This should reflect StepsLabel list */
export enum FormSteps {
    TollAccountDetails = 1,
    SoleTraderDetails = 2,
    SupportingDocuments = 3,
    Review = 4,
}
